import {
  CONFIG_RECEIVED_GET_VANADIUM_BESS_CONFIGS,
  CONFIG_RECEIVED_GET_VANADIUM_BESS_CONFIG,
  CONFIG_RECEIVED_UPDATE_VANADIUM_BESS_FACTORY,
  CONFIG_RECEIVED_UPDATE_VANADIUM_BESS_USER,
} from '../actions/config-actions';
import { copyObject } from '../utility';

export default function (state = { vanadiumBESS: [] }, action) {
  switch (action.type) {
    case CONFIG_RECEIVED_GET_VANADIUM_BESS_CONFIGS:
      return action.payload;

    case CONFIG_RECEIVED_GET_VANADIUM_BESS_CONFIG:
      return updateConfig(state, action.payload);

    case CONFIG_RECEIVED_UPDATE_VANADIUM_BESS_FACTORY:
    case CONFIG_RECEIVED_UPDATE_VANADIUM_BESS_USER:
      return updateSetting(state, action.payload);

    default:
      return state;
  }
}

function updateSetting(state, data) {
  let copy = copyObject(state);

  copy.vanadiumBESS.forEach((vanadium) => {
    if (vanadium.serial === data.serial) {
      if (data.user) {
        vanadium.config.user = data.user;
        vanadium.config.userHistory.push(data);
      } else if (data.factory) {
        vanadium.config.factory = data.factory;
        vanadium.config.factoryHistory.push(data);
      }
    }
  });

  return copy;
}

function updateConfig(state, data) {
  if (!data.vanadiumBESSs[0]) {
    return state;
  }
  let copy = copyObject(state);
  let found = false;
  copy.vanadiumBESS.forEach((vanadium, idx) => {
    if (vanadium.serial === data.vanadiumBESS[0].serial) {
      copy.vanadiumBESS[idx] = data.vanadiumBESS[0];
      found = true;
    }
  });
  if (!found) {
    copy.vanadiumBESS.push(data.vanadiumBESS[0]);
  }

  return copy;
}
